import { getOperationName } from '@apollo/client/utilities';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LoadingButton,
  SnackbarManager,
} from '@cmg/design-system';
import React from 'react';

import { useOfferingProfile_DeleteParticipationSetMutation } from './graphql/__generated__/DeleteParticipationSet';
import { OfferingProfile_GetParticipationRecordsDocument } from './graphql/__generated__/GetParticipationRecords';
import { dialogContentStyle } from './UploadParticipationSetModal.styles';

export type ImportSetDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  offeringId: string;
};
export const DeleteParticipationSetDialog: React.FC<ImportSetDialogProps> = ({
  isOpen,
  onClose,
  offeringId,
}) => {
  const [deleteParticipationSetMutation] = useOfferingProfile_DeleteParticipationSetMutation({
    refetchQueries: [getOperationName(OfferingProfile_GetParticipationRecordsDocument)!],
  });
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Delete Participation Data</DialogTitle>

      <DialogContent dividers sx={dialogContentStyle}>
        Are you sure you want to delete the participation data for this offering? All Investors and
        analytics for this offering will be removed.
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          onClick={async () => {
            try {
              await deleteParticipationSetMutation({
                variables: {
                  input: {
                    offeringId,
                  },
                },
              });
              SnackbarManager.success('File successfully deleted.');
              onClose();
            } catch (error) {
              SnackbarManager.error(
                'An error has occurred while trying to delete participation set. Please try again later.'
              );
              onClose();
            }
          }}
        >
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
